import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { LegislationCardTitleText } from '../card/LegislationCardTitleText';
import { Spacing } from '../../components/entities-card/Spacing';
import { EntitiesCardBodyLink } from '../../components/entities-card/EntitiesCardBodyLink';
import { TruncatedDefinition } from '../../components/popovers/truncated-definition/TruncatedDefinition';
import { TruncatedDefinitionFakeLink } from '../../components/popovers/truncated-definition/TruncatedDefinitionFakeLink';
import { LegislationCardVersion } from '../card/LegislationCardVersion';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import { ArticleStats } from '../../components/article-stats/ArticleStats';

import { useUser } from '../../user/useUser';

import { LegislationPopoverInfos } from '../legislation.types';

type Props = {
  legislation: LegislationPopoverInfos;
  source: string;
  target?: '_blank';
  url: string;
};

export const LegislationCard: FC<Props> = ({
  legislation,
  source,
  target,
  url,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (!accessPremium) {
      event.preventDefault();
      openRestrictedModal({ source });
    }
  };

  return (
    <EntitiesCardBodyLink
      href={accessPremium ? url : ''}
      onClick={handleClick}
      source={source}
      target={target}
    >
      <LegislationCardTitleText>{legislation.title}</LegislationCardTitleText>
      <LegislationCardVersion legislation={legislation} />
      <Spacing />
      <TruncatedDefinition text={legislation.textShort}>
        <TruncatedDefinitionFakeLink>
          <FormattedMessage id="legislation/components/popover/LegislationCard.tsx/1" />
        </TruncatedDefinitionFakeLink>
      </TruncatedDefinition>
      <ArticleStats
        articleId={legislation.articleId}
        url={url}
        sourcePage="decisionPageLink_popover"
      />
      <Spacing />
    </EntitiesCardBodyLink>
  );
};
